var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("dashboard "+_vm._s(_vm.account.company_name)+"\n\t"),_c('br'),_c('CumulioDashboard',{attrs:{"id":_vm.dashboardId,"params":_vm.params}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }